import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { RemoteDiagnosticsStore, VddDetailsListStore } from '@store';

import { ActivatedRoute } from '@angular/router';
import { DiagnosticsFormGroupService } from '../../../extended-parameters/diagnostics-view/diagnostics-form-group.service';

@Component({
  selector: 'app-show-live-vdd-table-item',
  templateUrl: './show-live-vdd-table-item.component.html',
  styleUrls: ['./show-live-vdd-table-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DiagnosticsFormGroupService],
})
export class ShowLiveVddTableItemComponent implements OnInit, OnDestroy {
  saveValueSubject: Subject<void> = new Subject<void>();
  gatewaySerial: string;
  @Input() vddName: string;

  isVddLoading: boolean;
  matchedValues: any;
  logicalLink: string;

  constructor(
    private vddDetailsListStore: VddDetailsListStore,
    private cdr: ChangeDetectorRef,
    public diagnosticsFormGroupService: DiagnosticsFormGroupService,
    private activatedRoute: ActivatedRoute,
    private remoteDiagnosticsStore: RemoteDiagnosticsStore
  ) {}

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    this.gatewaySerial = this.activatedRoute.snapshot.queryParams.gatewaySerial;

    this.remoteDiagnosticsStore
      .getLogicalLinkOfSelectedActiveError(this.gatewaySerial)
      .pipe(take(1))
      .subscribe((logicalLink) => {
        this.logicalLink = logicalLink;
        this.vddDetailsListStore
          .selectMatchedValues(this.vddName, logicalLink)
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe((values) => {
            this.matchedValues = values;
            this.cdr.detectChanges();
          });

        this.vddDetailsListStore
          .isVddLoading(this.vddName, logicalLink)
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe((isVddLoading) => {
            this.isVddLoading = isVddLoading;
            this.cdr.detectChanges();
          });
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
